// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "bh_b3";
export var MuiTooltipPopper = "bh_b4";
export var button = "bh_b7";
export var icon = "bh_n";
export var iconWrapper = "bh_b6";
export var title = "bh_bl";
export var wrapper = "bh_b5";